export default __webpack_public_path__ + "static/media/KGZ.053dadf9.svg";